import React from 'react'
import classes from './WidgetCard.module.scss'
import classNames from 'classnames'

export interface WidgetCardProps {
  className?: string
  children: React.ReactNode
  onClick?: () => void
  accessibilityLabel?: string
}

export const WidgetCard: React.FC<WidgetCardProps> = ({
  children,
  onClick,
  className,
  accessibilityLabel,
}) => (
  <div
    className={classNames(classes.card, className, { [classes.clickable]: onClick })}
    onClick={onClick}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={e => {
      if (onClick && (e.key === 'Enter' || e.key === ' ')) {
        onClick()
      }
    }}
    aria-label={accessibilityLabel}
  >
    {children}
  </div>
)
